import { DeleteOutlined } from '@ant-design/icons';
import { Modal, Typography } from 'antd';

import { CloseIconsForModalWithDataTestId } from '@app/components';
import { generateSpanWithDataTestId } from '@app/shared/utils';

import type { TemplateDeletionDialogType } from '@pages/Users/AccessRightsTab/types';

const { Text } = Typography;

export const TemplateDeletionDialog: TemplateDeletionDialogType = ({
  isLoading,
  isOpened,
  onCancel,
  onOk,
}) => (
  <Modal
    title={generateSpanWithDataTestId(
      'Удаление шаблона прав',
      'delete-rights-template-title'
    )}
    data-testid="delete-rights-template-popup"
    open={isOpened}
    okText="Удалить"
    okButtonProps={{
      danger: true,
      icon: <DeleteOutlined />,
      loading: isLoading,
      'data-testid': 'delete-template',
    }}
    cancelButtonProps={{
      disabled: isLoading,
      'data-testid': 'cancel',
    }}
    cancelText="Отменить"
    onOk={onOk}
    onCancel={onCancel}
    closeIcon={<CloseIconsForModalWithDataTestId />}
  >
    <Text data-testid="delete-rights-template-description">
      Вы уверены, что хотите безвозвратно удалить шаблон?
    </Text>
  </Modal>
);
